import { PersistedQuizSession } from '../types/glossaryQuiz'

const QUIZ_SESSION_KEY = 'ms_glossary_quiz_session'

export const saveQuizSession = (session: PersistedQuizSession): void => {
  localStorage.setItem(QUIZ_SESSION_KEY, JSON.stringify(session))
}

export const loadQuizSession = (): PersistedQuizSession | null => {
  const rawSession = localStorage.getItem(QUIZ_SESSION_KEY)
  if (!rawSession) {
    return null
  }

  try {
    return JSON.parse(rawSession) as PersistedQuizSession
  } catch {
    return null
  }
}

export const clearQuizSession = (): void => {
  localStorage.removeItem(QUIZ_SESSION_KEY)
}
